import { render, staticRenderFns } from "./OrgTeachers.vue?vue&type=template&id=18872a5d&scoped=true"
import script from "./OrgTeachers.vue?vue&type=script&lang=js"
export * from "./OrgTeachers.vue?vue&type=script&lang=js"
import style0 from "./OrgTeachers.vue?vue&type=style&index=0&id=18872a5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18872a5d",
  null
  
)

export default component.exports